/**
 * Fichier généré automatiquement.
 *
 * Source : config/prod.env
 * Ne pas modifier manuellement.
 */

export const generatedEnvironment = {
  "clientId": "app_h7C0rT6fcUjdmmt4fCASbBQx",
  "databases": {
    "cachingRequest": {
      "secret": "9d82ff750ab6a27ac68f8555fa0176a8e2",
      "newSecret": "559d3a7b3b9313e3fca87da49de650b303"
    },
    "storage": {
      "secret": "2139ca63e9676965fcac0c8c3dc24888d7",
      "newSecret": "8887633bebe1464bb88c0ff8479141bd7b"
    },
    "authentification": {
      "secret": "4192639f680e37202db74d3d48306e8367",
      "newSecret": "a2c5477fda2af8a8429b185f1524e8a668"
    }
  },
  "uuid": "f08781b0-fe2f-8ace-a349-2a2a98074be3"
} as const;
